module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_9005.fbd8f385.png";